import { type DocumentNode, gql } from '@apollo/client';

/**
 * Variables for allThemes query
 */
export interface AllThemesVariables {
  name?: string;
}

/**
 * Theme node structure
 */
export interface ThemeNode {
  id: string;
  name: string;
  primary: string;
  secondary: string;
}

/**
 * Theme edge structure
 */
export interface ThemeEdge {
  node: ThemeNode;
}

/**
 * All themes connection structure
 */
export interface AllThemesConnection {
  edges: ThemeEdge[];
}

/**
 * Response structure for allThemes query
 */
export interface AllThemesResponse {
  allThemes: AllThemesConnection;
}

const allThemesFiltered: DocumentNode = gql`
  query allThemes($name: String) {
    allThemes(name: $name) {
      edges {
        node {
          id
          name
          primary
          secondary
        }
      }
    }
  }
`;

export default allThemesFiltered;
